module.exports = __webpack_public_path__ + "static/media/travel-agent.82d28be2.svg";